
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    name: 'ChangeLog',
    components: {
        Icon
    },
    props: {
        changeLog: {
            type: Object,
            required: true
        }
    }
}
